
<div class="sticky-box">
	<!-- @slot Used to display Deatils  -->
	<slot name="detail" />
</div>
